<ul class="horizontal-menu">
  <li class="mega-menu">
    <a href="javascript:void(0)" class="nav-link megamenu-mob"  style="display: none;margin-top: -15%;" [class.active]="navServices.megaMenu" (click)="megaMenuToggle()">
      <app-feather-icons [icon]="'power'"></app-feather-icons>
    </a>
    <div class="mega-menu-container nav-submenu menu-to-be-close" [class]="navServices.megaMenu ? 'd-block' : 'd-none'">
      <div class="container-fluid">
        <div class="row">
          <!-- <div class="media profile-media">
            <img class="b-r-10" src="assets/images/dashboard/profile.jpg" alt="">
            <div class="media-body"><span>{{displayName}}</span>
              <p class="mb-0 font-roboto">{{userType}} <i class="middle fa fa-angle-down"></i></p>
            </div>
          </div> -->
          <div class="col mega-box mobile-title d-none">            
            <div class="media-body">
              <h5>{{displayName}}</h5>
              <p class="mb-0 font-roboto">{{userType}}</p>
            </div>
            <app-feather-icons [icon]="'x'" (click)="megaMenuToggle()"></app-feather-icons>
          </div>
          
          <div class="col mega-box">
            <div class="link-section icon" style="padding: 5%;border-bottom: solid #ebf5eb;margin-top: 10px;">
              <a [routerLink]="'/user/profile'"><app-feather-icons [icon]="'user'"></app-feather-icons><h5 style="display: inline;padding-left: 12px;">Account</h5></a>              
            </div>
            <div class="link-section icon" style="padding: 5%;border-bottom: solid #ebf5eb;margin-top: 10px;">
              <a [routerLink]="'/user/noti-settings'"><app-feather-icons [icon]="'settings'"></app-feather-icons><h5 style="display: inline;padding-left: 12px;">Notifications</h5></a>
            </div>
            <div class="link-section icon" style="padding: 5%;border-bottom: solid #ebf5eb;margin-top: 10px;">
              <a (click)="logout()"><app-feather-icons [icon]="'log-out'"></app-feather-icons><h5 style="display: inline;padding-left: 12px;">Logout</h5></a>
            </div>
          </div>
          <!-- <div class="col mega-box" *ngFor="let megaItem of megaItems">
            <div class="link-section icon" (click)="toggletNavActive(megaItem)">
              <div [class.active]="megaItem.active && navServices.megaMenuColapse">
                <h6>{{megaItem.title}}</h6>
              </div>
              <ul [class.d-none]="!megaItem.active && navServices.megaMenuColapse" *ngIf="megaItem.children">
                <li *ngFor="let childrenMegaItem of megaItem.children">
                  <a [routerLink]="!childrenMegaItem.type ? null : [childrenMegaItem.path]"
                    *ngIf="childrenMegaItem.type === 'link'" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    {{childrenMegaItem.title}}
                  </a>
                  <a href="{{ !childrenMegaItem.type ? null : childrenMegaItem.path }}"
                    *ngIf="childrenMegaItem.type === 'extLink'" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    {{childrenMegaItem.title}}
                  </a>
                  <a href="{{ !childrenMegaItem.type ? null : childrenMegaItem.path }}" target="_blank"
                    *ngIf="childrenMegaItem.type === 'extTabLink'">
                    {{childrenMegaItem.title}}
                  </a>
                </li>
              </ul>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </li>
  <!-- <li class="level-menu">
    <ul class="header-level-menu menu-to-be-close" [class]="navServices.levelMenu ? 'd-block' : 'd-none'">
      <li *ngFor="let levelmenuitem of levelmenuitems">
        <a href="javascript:void(0);" *ngIf="levelmenuitem.type === 'sub'">
          <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
          <span>{{levelmenuitem.title}}</span>
        </a>
        <a [routerLink]="!levelmenuitem.type ? null : [levelmenuitem.path]"
          *ngIf="levelmenuitem.type === 'link'" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
          <span>{{levelmenuitem.title}}</span>
        </a>
        <a href="{{ !levelmenuitem.type ? null : levelmenuitem.path }}"
          *ngIf="levelmenuitem.type === 'extLink'" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
          <span>{{levelmenuitem.title}}</span>
        </a>
        <a href="{{ !levelmenuitem.type ? null : levelmenuitem.path }}" target="_blank"
          *ngIf="levelmenuitem.type === 'extTabLink'">
          <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
          <span>{{levelmenuitem.title}}</span>
        </a>
        <ul class="header-level-sub-menu" *ngIf="levelmenuitem.children">
          <li *ngFor="let childrenItem of levelmenuitem.children">
            <a [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
              *ngIf="childrenItem.type === 'link'" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <app-feather-icons [icon]="childrenItem.icon"></app-feather-icons>
              <span>{{childrenItem.title}}</span>
            </a>
            <a href="{{ !childrenItem.type ? null : childrenItem.path }}"
              *ngIf="childrenItem.type === 'extLink'" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <app-feather-icons [icon]="childrenItem.icon"></app-feather-icons>
              <span>{{childrenItem.title}}</span>
            </a>
            <a href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank"
              *ngIf="childrenItem.type === 'extTabLink'">
              <app-feather-icons [icon]="childrenItem.icon"></app-feather-icons>
              <span>{{childrenItem.title}}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </li> -->
</ul>
